module.exports = __webpack_public_path__ + "static/media/ThamesYouTube.0356616b.jpg";